import React from 'react'
import { reducer, initialState } from './reducer'

export const SavedViewContext = React.createContext({
  savedViewState: initialState,
  savedViewDispatch: () => null,
})

export const SavedViewProvider = ({ children }) => {
  const [savedViewState, savedViewDispatch] = React.useReducer(
    reducer,
    initialState,
  )

  return (
    <SavedViewContext.Provider value={[savedViewState, savedViewDispatch]}>
      {children}
    </SavedViewContext.Provider>
  )
}
